import {Component, ElementRef, HostListener, Inject, OnInit, PLATFORM_ID, ViewChild, Input, Output, EventEmitter, OnDestroy} from '@angular/core';
import {DataService} from '../../shared/services/data.service';
import {Subscription} from 'rxjs';
import {ApiServices} from '../../shared/services/api.service';
import { SearchResult } from '../../shared/interfaces/Search.interface';
import {Router,Event} from '@angular/router';
import {HelperService} from '../../shared/services/helper.service';
import {isPlatformBrowser} from '@angular/common';
import {ImagePathPipe} from '../../shared/pipes/image-path.pipe';
import {BaseImagePipe} from '../../shared/pipes/base-image.pipe';
import { ToastrService } from 'ngx-toastr';

import * as $ from 'jquery';
import { MyProfile } from 'src/app/shared/interfaces/MyAccount.interface';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  providers: [
    ImagePathPipe,
    BaseImagePipe
  ]
})
export class HeaderComponent implements OnInit, OnDestroy {

  cartCount = 0;
  isLoggedIn = false;
  searchSubscription: Subscription;
  searchResult: SearchResult;
  searcKeyWord:any = null;
  newSearcTem:any = 'none';
  profileData: MyProfile;
  is_hide_cost:any;
  currentRoute:any;
  replace_logo: any;

  logoPath:string = '/assets/img/new-logo.png';
  originalLogo:string = '/assets/img/new-logo.png';
  imageBasePath:string = "https://d2iosncs8hpu1u.cloudfront.net/";
  private sub: Subscription;

  isDropdownOpen: boolean = false;

    openDropdown() {
        this.isDropdownOpen = true;
    }

    closeDropdown() {
        this.isDropdownOpen = false;
    }



  @ViewChild('searchElement') searchElement: ElementRef;
  constructor(
    private dataService: DataService,
    private apiService: ApiServices,
    private router: Router,
    public helperService: HelperService,
    private imagePath:ImagePathPipe,
    private baseImage:BaseImagePipe,
    private toastr: ToastrService,
    @Inject(PLATFORM_ID) private platformID: any,
  ) {
    
    if (isPlatformBrowser(this.platformID)) {
      this.dataService.cartCount.asObservable().subscribe(count => this.cartCount = count);

      this.dataService.dealerlogo.asObservable().subscribe(logoPath => {
        this.logoPath = logoPath;
        if(this.logoPath === null) {
          this.logoPath = '/assets/img/new-logo.png';
          this.dataService.dealerlogo.next('/assets/img/new-logo.png');
        }

      });

      this.dataService.isLoggedIn.asObservable().subscribe(loggeind => {
        this.isLoggedIn = loggeind;
        if (!this.isLoggedIn) {
          this.checkIfalreadyLoggedIn();
        } else {
          this.dataService.dealerlogo.next('/assets/img/new-logo.png');
        }
      });
    }
  }

  @HostListener('document:click', ['$event']) onDocumentClick(event) {
    if(this.isLoggedIn){
      this.searchResult = null;
      this.searchElement.nativeElement.value = '';
    }
  }

  resolveProfilePage(): void {
    this.sub = this.dataService.myAccountData.asObservable().subscribe(
      myAccountData => {
        if(myAccountData) {
          this.profileData = myAccountData.my_profile;
          const prevUserData = JSON.parse(localStorage.getItem('ts_user_data'));
          const newUserData = this.profileData;
          const localStorageData = JSON.parse(localStorage.getItem('ts_user_data'));
          localStorageData.user_data = {...prevUserData, ...newUserData};
          localStorage.setItem('ts_user_data', JSON.stringify(localStorageData));
          
          // Security: Use secure method to determine cost hiding
          this.is_hide_cost = this.helperService.shouldHideCost(this.profileData) ? 1 : 0;
          
          // Security: Use feature-based logo checking
          if(!this.helperService.canUseCustomBranding(this.profileData)) {
            this.logoPath = '/assets/img/new-logo.png';
            this.dataService.dealerlogo.next(this.logoPath);
          }
          if((this.profileData?.is_replace_logo == 1) && this.helperService.canUseCustomBranding(this.profileData)) {
            if(this.profileData.business_logo != null){
              this.logoPath = this.imageBasePath+this.profileData.business_logo;
              this.dataService.dealerlogo.next(this.logoPath);
            }
          }
        } else {
          const token = localStorage.getItem('ts_vendor_access_token');
          if(token) {
            this.helperService.getMyAccountData();
          }
        }
      }
    );
  }

  checkIfalreadyLoggedIn() {
    const token = localStorage.getItem('ts_vendor_access_token');
    if(token) {
      this.isLoggedIn = true;

      const userData = JSON.parse(localStorage.getItem('ts_user_data'));
      if((this.profileData?.is_replace_logo == 1) && (this.helperService.isSubscribed(this.profileData, 'plus-plan') || this.helperService.isSubscribed(this.profileData, 'premium-plan'))) {
        if(userData.user_data.business_logo != null){
          this.logoPath = this.imageBasePath+userData.user_data.business_logo;
          this.dataService.dealerlogo.next(this.logoPath);
        }
      }

      this.dataService.isLoggedIn.next(this.isLoggedIn);
    } else {
      this.dataService.dealerlogo.next('/assets/img/white-new-logo.png');
      this.isLoggedIn = false;
    }
  }




  ngOnInit(): void {
    // console.log(this.currentRoute);
    this.newSearcTem = 'none';
    this.resolveProfilePage();
    // setTimeout(() => this.resolveProfilePage(), 2000);
  }

  ngOnDestroy(): void {
      if(this.sub) {
        this.sub.unsubscribe();
      }
  }


  logoRedirection(){
    if(!this.isLoggedIn){
      this.router.navigateByUrl('/');
    } else {
      this.router.navigateByUrl('/profile-dashboard')
    }
  }

  logout() {
    this.dataService.dealerlogo.next('/assets/img/white-new-logo.png');
    this.helperService.logout();
    this.router.navigateByUrl('/');
  }

  toggleCostSetting(event: any, event_type:string, showCost:number){
    // Security: Validate user has permission to change cost settings
    if (!this.helperService.canHideCostPrice(this.profileData)) {
      console.warn('🚨 Unauthorized attempt to change cost settings');
      this.toastr.warning('Cost hiding feature requires Premium plan. Please upgrade to access this feature.');
      return;
    }

    if ( event_type == 'click') {
      event.target.closest(".dropdown-submenu").querySelectorAll(".form-check-input").forEach((fa) => {
        fa.checked = false;
      });
      let radioElem = event.target.closest(".form-check").querySelector(".form-check-input");
      radioElem.checked = true
    }
    showCost == 1 ? localStorage.removeItem('is_hide_cost') : localStorage.setItem("is_hide_cost", '1');
    localStorage.setItem('override_cost_setting', 'true');
    location.reload();
  }

  onSearch($event): void {
    if ($event.target.value) {
      this.searcKeyWord = $event.target.value;
      this.searchSubscription = this.apiService.search($event.target.value).subscribe(
        response => {
            this.searchResult = response.result;
        }
      );
    } else {
      this.searchResult = null;
    }
  }
  goSearchPage(): void{
    $('body .opac-layer').click();
    this.newSearcTem = 'none';
    if(this.searcKeyWord != '' && this.searcKeyWord != undefined && this.searcKeyWord != null){
      this.newSearcTem = 'none';
      this.router.navigateByUrl('/search?keywords='+this.searcKeyWord);
    }
  }

  showNewResultTemplate():void {
    // console.log("test");
    this.newSearcTem = 'block';
  }

  hideSearchBar(url1, url2):void{
    this.newSearcTem = 'none';
    $('body .opac-layer').click();
    if(url1 == "wheelbrand"){
      this.searcKeyWord = '';
      this.router.navigateByUrl('/wheels?brand='+url2);
      // this.router.navigateByUrl('/'+url1+'/'+url2+'?brand='+url2);
    } else {
      this.searcKeyWord = '';
      this.router.navigateByUrl('/'+url1+'/'+url2);
    }
  }
  clearSearchWord():void{
    this.searcKeyWord = '';
  }

  isFeatureRoute(): boolean {
    return this.router.url === '/feature' || this.router.url === '/feature#supplierfeature';
  }

}
